//import React from 'react'
import { formatDate } from "../../util"

const DateRenderer = ({ info, value }) =>
    formatDate(typeof value === "string" ? new Date(value) : value, "ro", info.fieldInfo.showTime)

export default DateRenderer
